// Payment Gateway Service for ICICI Integration via Backend API
// File: src/services/PaymentGatewayService.js

import axiosInstance from "./AxiosInstance";

class PaymentGatewayService {
  constructor() {
    this.config = {
      RETURN_URL: window.location.origin + "/payment/return",
      CANCEL_URL: window.location.origin + "/payment/cancel",
    };
  }

  async initiatePaymentSale(paymentData) {
    try {
      console.log("🚀 Initiating ICICI payment via backend:", paymentData);

      // Get authentication tokens with fallback for public access
      // Prepare request payload with authentication
      const requestPayload = {
        // return_url_flag: false,
   
        // Include all payment data in snake_case format as expected by API
        patient_id: paymentData.patient_id || paymentData.patientId,
        appointment_id:
          paymentData.appointment_id || paymentData.appointmentId || "0",
        lead_id: paymentData.lead_id || paymentData.leadId || null,
        prescription_id:
          paymentData.prescription_id || paymentData.prescriptionId || null,
        queue_id: paymentData.queue_id || paymentData.queueId || null,
        payment_for:
          paymentData.payment_for || paymentData.paymentFor || "Patient Queue",
        amount: paymentData.amount,
        customerName: paymentData.customer_name || paymentData.customerName,
        customerEmail: paymentData.customer_email || paymentData.customerEmail,
        customerPhone: paymentData.customer_mobile || paymentData.customerPhone,
        customerAddress:
          paymentData.customer_address || paymentData.customerAddress || "",
        description: paymentData.description,
        // Add reference ID and coupon code
        reference_id: paymentData.reference_id || paymentData.referenceId || null,
        coupon_code: paymentData.coupon_code || paymentData.couponCode || null,
      };

      // Filter out zero values from request payload
      const filteredPayload = {};
      Object.keys(requestPayload).forEach((key) => {
        const value = requestPayload[key];
        // Skip if value is "0", 0, null, undefined, or empty string
        if (
          value !== "0" &&
          value !== 0 &&
          value !== null &&
          value !== undefined &&
          value !== ""
        ) {
          filteredPayload[key] = value;
        }
      });

      console.log("📤 Final request payload being sent:", filteredPayload);

      // Validate required fields

      console.log("✅ Validation passed, making API call...");

      const response = await axiosInstance.post(
        "/icici/initiate",
        filteredPayload
      );

      console.log("📥 Backend response:", response.data);

      if (response.data?.success) {
        return {
          success: true,
          data: response.data.data,
          message: response.data.message || "Payment initiated successfully",
        };
      } else {
        throw new Error(
          response.data?.message || "Failed to initiate payment"
        );
      }
    } catch (error) {
      console.error("❌ Payment initiation error:", error);
      return {
        success: false,
        error:
          error.response?.data?.message ||
          error.message ||
          "Failed to initiate payment",
      };
    }
  }

  async checkPaymentStatus(merchantTxnNo) {
    try {
      console.log("🔍 Checking payment status for:", merchantTxnNo);

      // Get authentication tokens with fallback for public access
      const requestPayload = {
    
        merchant_txn_no: merchantTxnNo,
      };

      const response = await axiosInstance.post(
        `/payment/status`,
        requestPayload
      );

      return response.data;
    } catch (error) {
      console.error("❌ Status check error:", error);
      throw error;
    }
  }

  async updatePaymentStatus(updateData) {
    try {
      console.log("🔄 Updating payment status:", updateData);

      const requestPayload = {
        merchant_txn_no: updateData.merchant_txn_no || updateData.merchantTxnNo,
        status: updateData.status,
        // Add reference ID and coupon code for status updates
        reference_id: updateData.reference_id || updateData.referenceId || null,
        coupon_code: updateData.coupon_code || updateData.couponCode || null,
        // Additional fields that might be needed for status update
        payment_id: updateData.payment_id || updateData.paymentId || null,
        transaction_id: updateData.transaction_id || updateData.transactionId || null,
        remarks: updateData.remarks || null,
        updated_by: updateData.updated_by || updateData.updatedBy || null,
      };

      // Filter out null/undefined values
      const filteredPayload = {};
      Object.keys(requestPayload).forEach((key) => {
        const value = requestPayload[key];
        if (value !== null && value !== undefined && value !== "") {
          filteredPayload[key] = value;
        }
      });

      console.log("📤 Update payment status payload:", filteredPayload);

      const response = await axiosInstance.post(
        `/payment/update-status`,
        filteredPayload
      );

      console.log("📥 Update status response:", response.data);

      if (response.data?.success) {
        return {
          success: true,
          data: response.data.data,
          message: response.data.message || "Payment status updated successfully",
        };
      } else {
        throw new Error(
          response.data?.message || "Failed to update payment status"
        );
      }
    } catch (error) {
      console.error("❌ Update payment status error:", error);
      return {
        success: false,
        error:
          error.response?.data?.message ||
          error.message ||
          "Failed to update payment status",
      };
    }
  }

  // Test backend connection
  // Process refund
  async processRefund(refundData) {
    try {
      console.log("💰 Processing refund:", refundData);


      const requestPayload = {
        ...refundData,
      };

      const response = await axiosInstance.post(
        `/payment/refund`,
        requestPayload
      );

      return response.data;
    } catch (error) {
      console.error("❌ Refund error:", error);
      throw error;
    }
  }
}

// Create and export singleton instance
const paymentGatewayService = new PaymentGatewayService();
export default paymentGatewayService;
